import React from 'react';
import { Button, Result } from 'antd';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Page500 = () => {

    const { t } = useTranslation();

    return (

        <Result
            status="500"
            title="500"
            subTitle={t('configurator.500_subtitle')}
            extra={
                <Link to="/">
                    <Button type="primary">Homepage</Button>
                </Link>
            }
        />
    );
}

export default Page500;